<template>
  <v-container>
    <v-overlay :value="!!$route.params.yaziID && yaziGuncelleData === null" :opacity="0.2" color="white">
      <v-card color="primary" dark width="250">
        <v-card-text class="pt-1">
          <div class="py-2 text-center">{{ $t("YAZILAR.DETAIL.LOADING_POST_DETAIL") }}</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-row>
      <v-col cols="12" class="pb-0">
        <panel-title v-if="!yaziGuncelleData" icon="mdi-pencil-plus" :title="$t('YAZILAR.DETAIL.ADD_POST_TITLE')" :desc="$t('YAZILAR.DETAIL.ADD_POST_SUB_TITLE')">
          <template v-slot:append-inner>
            <v-btn small class="text-capitalize" @click="$router.back()" outlined color="error">
              <v-icon size="15" class="mr-1">mdi-close</v-icon>
              {{ $t("YAZILAR.DETAIL.CANCEL_ADDING") }}
            </v-btn>
          </template>
        </panel-title>
        <panel-title v-else icon="mdi-file-edit-outline" :title="$t('YAZILAR.DETAIL.UPDATE_POST_TITLE')" :desc="$t('YAZILAR.DETAIL.UPDATE_POST_SUB_TITLE')">
          <template v-slot:append-inner>
            <v-btn small class="text-capitalize" @click="$router.back()" outlined color="error">
              <v-icon size="15" class="mr-1">mdi-close</v-icon>
              {{ $t("YAZILAR.DETAIL.CANCEL_UPDATING") }}
            </v-btn>
          </template>
        </panel-title>
      </v-col>

      <v-col cols="12" lg="9">
        <v-card class="px-2 py-2 mb-3" rounded="md">
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-0 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.TYPING.POST_TITLE") }}
            </p>
          </div>
          <div class="py-2">
            <!--    Language Data    -->
            <!-- <language-structured-data v-if="yaziData.baslik" ref="languageStructuredData" v-model="yaziData.baslik" @change="languageStructuredIsChanged">
              <template v-slot="{ data }"> -->
                <v-text-field :label="$t('YAZILAR.DETAIL.TYPING.POST_TITLE_LABEL')" v-model="yaziData.baslik" hide-details outlined dense></v-text-field>
              <!-- </template>
            </language-structured-data> -->
            <!--    ./Language Data    -->
          </div>
          <v-divider class="my-2"></v-divider>
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.TYPING.POST_CONTENT_TITLE") }}
            </p>
          </div>
          <div>
            <cheetah-editor
              v-model="editorIcerik"
              :set-content="setContent"
              editor-base-color="pink darken-1"
              editor-selecting-color="pink darken-4"
              editor-passive-color="pink lighten-5"
              editor-border-color="#F48FB1"
            />
          </div>
          <v-divider class="my-3"></v-divider>
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.TYPING.SEO_DESCRIPTION_TITLE") }}
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    class="text-capitalize"
                    x-small
                    :color="!seoIcerikEvent ? 'grey darken-3 white--text' : 'grey lighten-2'"
                    @click="seoIcerikEvent = !seoIcerikEvent"
                  >
                    <v-icon size="15" class="mr-1">mdi-link-variant</v-icon>
                    <span v-show="seoIcerikEvent">{{ $t("YAZILAR.DETAIL.TYPING.BIND_TO_CONTENT_BTN") }}</span>
                    <span v-show="!seoIcerikEvent">{{ $t("YAZILAR.DETAIL.TYPING.DETACH_FROM_CONTENT_BTN") }}</span>
                  </v-btn>
                </template>
                <span v-show="seoIcerikEvent">{{ $t("YAZILAR.DETAIL.TYPING.BIND_TO_CONTENT_BTN") }}</span>
                <span v-show="!seoIcerikEvent">{{ $t("YAZILAR.DETAIL.TYPING.DETACH_FROM_CONTENT_BTN") }}</span>
              </v-tooltip>
            </p>
          </div>
          <div>
            <v-textarea
              v-model="yaziData.seoIcerik"
              outlined
              height="80"
              :counter="seoIcerikLimit"
              :rules="rules.seoIcerik"
              @focus="seoIcerikEvent = true"
              :label="$t('YAZILAR.DETAIL.TYPING.SEO_DESCRIPTION_LABEL')"
            ></v-textarea>
          </div>
          <v-divider class="my-3 mt-0"></v-divider>
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.TYPING.PERMANENT_LINK") }}
            </p>
          </div>
          <div class="yazi-field">
            <v-text-field outlined dense :prefix="siteUrl" :readonly="readonly" hide-details v-model="yaziData.link" ref="seoLink">
              <template v-slot:append-outer class="my-0">
                <v-tooltip bottom v-if="!editLink">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" color="pink darken-1" fab small dark @click="linkEdit">
                      <v-icon>mdi-pen</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("YAZILAR.DETAIL.TYPING.EDIT_LINK_BTN") }}</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" color="success" fab small dark @click="linkEdit" :loading="editLinkLoading">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("YAZILAR.DETAIL.TYPING.SAVE_LINK_BTN") }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3">
        <v-card class="px-2 py-2 pb-4 mb-4">
          <div>
            <p class="text-subtitle-1 mb-1 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.ACTIONS.TITLE") }}
            </p>
          </div>
          <div>
            <v-menu offset-y :nudge-bottom="2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="!yaziGuncelleData" :loading="yaziDataLoading" v-on="on" v-bind="attrs" width="100%" dark color="pink darken-1">
                  <v-icon left>mdi-note-plus-outline</v-icon>
                  {{ $t("YAZILAR.DETAIL.ACTIONS.ADD_POST_BTN") }}
                </v-btn>
                <v-btn v-else :loading="yaziDataLoading" v-on="on" v-bind="attrs" width="100%" dark color="success">
                  <v-icon left>mdi-note-plus-outline</v-icon>
                  {{ $t("YAZILAR.DETAIL.ACTIONS.UPDATE_POST_BTN") }}
                </v-btn>
              </template>
              <v-list v-if="!yaziDataLoading" :class="!yaziGuncelleData ? 'pink lighten-5' : 'success lighten-5'" class="py-0">
                <v-list-item link @click="!yaziGuncelleData ? yaziEkle(1) : yaziyiGuncelle(1)" color>
                  <div>
                    <v-icon color left>mdi-check-all</v-icon>
                    <span class="grey--text text--darken-3">{{ $t("YAZILAR.DETAIL.ACTIONS.PUBLISH_NOW_BTN") }}</span>
                  </div>
                </v-list-item>
                <v-list-item link @click="!yaziGuncelleData ? yaziEkle(0) : yaziyiGuncelle(0)" color>
                  <div>
                    <v-icon color left>mdi-text-box-check</v-icon>
                    <span class="grey--text text--darken-3">{{ $t("YAZILAR.DETAIL.ACTIONS.MARK_AS_DRAFT_BTN") }}</span>
                  </div>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-card>
        <v-card class="px-2 py-2 pb-4 mb-4">
          <div>
            <p class="text-subtitle-1 mb-1 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.CATEGORY_SELECTING.TITLE") }}
            </p>
          </div>
          <div>
            <v-treeview class="text-body-2" :items="kategorisizItem" selection-type="independent" selected-color="pink darken-1" off-icon="mdi-checkbox-marked" dense>
              <template v-slot:prepend>
                <div class="d-flex align-center mb-2">
                  <v-checkbox v-model="kategorisizCheck" hide-details color="pink darken-1" class="my-0 py-0" :ripple="false" readonly></v-checkbox>
                  <span class="text-body-2">{{ $t("YAZILAR.DETAIL.CATEGORY_SELECTING.UNCATEGORIZED") }}</span>
                </div>
              </template>
            </v-treeview>
            <v-treeview
              class="text-body-2"
              v-model="secilenYaziKategorileri"
              :items="yaziKategorileri"
              selection-type="independent"
              selected-color="pink darken-1"
              selectable
              :open="treeViewAktifKategoriler"
              open-on-click
            ></v-treeview>
          </div>
        </v-card>
        <v-card class="px-2 py-2 mb-3" rounded="lg">
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.THUMBNAIL_TEXT") }}
              <v-spacer></v-spacer>
              <v-btn v-if="yaziData.thumbnail" color="red" dark class="text-capitalize" x-small @click="yaziData.thumbnail = null">
                <v-icon class="mr-1" size="1rem">mdi-trash-can-outline</v-icon>
                {{ $t("YAZILAR.DETAIL.THUMBNAIL_REMOVE") }}
              </v-btn>
            </p>
          </div>
          <div>
            <thumbnail-viewer :no-text="$t('YAZILAR.DETAIL.THUMBNAIL_NOT_SELECT')" :loading-text="$t('YAZILAR.DETAIL.THUMBNAIL_LOADING')" v-model="yaziData.thumbnail" />
          </div>
        </v-card>
        <v-card class="px-2 py-2 mb-3" rounded="lg">
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="pink darken-1" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>
              {{ $t("YAZILAR.DETAIL.TAGS") }}
            </p>
          </div>
          <div>
            <v-combobox label="Etiket girişi yapın" v-model="yaziData.tags" chips multiple color="pink darken-1" hide-details outlined>
              <template v-slot:selection="{ index, item }">
                <v-sheet color="pink darken-1" rounded="xl" class="px-2 py-1 mr-2 mb-1" @click="yaziData.tags.splice(index, 1)">
                  <span class="text-body-2 white--text">{{ item }}</span>
                  <v-btn icon class="ml-1" x-small>
                    <v-icon size="1rem" color="white">mdi-close</v-icon>
                  </v-btn>
                </v-sheet>
              </template>
            </v-combobox>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="yaziKaldir.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="yaziKaldir.dialog = false">
            {{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="yaziKaldir.loading" @click="yaziyiKaldir()">
            {{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CheetahEditor from "../../../components/CheetahEditor.vue";
import PanelTitle from "../../../components/PanelTitle.vue";
import ThumbnailViewer from "../../../components/ThumbnailViewer.vue";
import LanguageStructuredData from "@/components/LanguageStructuredData.vue";
import YazilarService from "@/services/YazilarService.js";
import RouterService from "@/services/RouterService.js";
import OptionService from "@/services/OptionService.js";
import { prepare, prepareFromData } from "@/core/modules/LanguageStructuredData";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  components: { CheetahEditor, PanelTitle, ThumbnailViewer, LanguageStructuredData },
  name: "YaziDetay",
  data: vm => ({
    yaziKategorileri: [],
    treeViewAktifKategoriler: [],
    secilenYaziKategorileri: [],
    kategorisiz: [],

    kategorisizItem: [
      {
        id: 0,
        name: ""
      }
    ],
    yaziData: {
      yaziCode: "",
      baslik: "",
      icerik: "",
      seoIcerik: "",
      link: "",
      thumbnail: "",
      kategoriler: [],
      fields: [],
      tags: []
    },

    yaziGuncelleData: null,
    editorIcerik: "",
    setContent: "",
    editLink: false,
    editLinkLoading: false,
    readonly: true,
    baslikTimeout: "",

    rules: {
      seoIcerik: [value => (value || "").length <= vm.seoIcerikLimit || vm.$t("YAZILAR.DETAIL.TYPING.SEO_CONTENT_WARN")]
    },

    seoIcerikLimit: 160,
    seoIcerikEvent: false,
    siteUrl: "",
    defaultUrl: "https://siteadresi.com/",
    yaziListesi: [],
    guncelYaziListesi: [],

    yaziDataMap: {
      yaziCode: "code",
      baslik: "name",
      // icerik: "desc",
      // seoIcerik: "seoIcerik",
      link: "link",
      thumbnail: "thumbnail",
      parent: "parent"
    },

    baslikSeoLinkTimeout: 650,

    yaziKaldir: {
      yaziCode: 0,
      dialog: false,
      loading: false
    },

    lastID: 1,

    yaziDataLoading: false,

    currentCode: null,
  }),
  computed: {
    ...mapState({
      yazilarKategoriListesi: state => state.Yazilar.YaziKategorileri.kategoriListesi,
      apiLanguage: state => state.Language.apiLanguage
    }),
    /**
     * @returns {Boolean}
     */
    kategorisizCheck() {
      return this.secilenYaziKategorileri.length === 0;
    },
    currentLanguageCode() {
      return this.$route.query.lang || this.currentCode || this.apiLanguage;
    },
  },
  methods: {
    linkEdit() {
      this.$refs.seoLink.$el.querySelector("input").focus();
      if (this.editLink) {
        this.readonly = true;
        this.checkLink(this.yaziData.link).then(() => (this.editLink = false));
      } else {
        this.readonly = false;
        this.editLink = true;
      }
    },
    checkLink(link) {
      this.editLinkLoading = true;

      /**
       * Veri güncelleme verisi ise link'i ona göre getir
       */
      let seoUrlMethod = "seoUrl",
        update = null;
      if (this.yaziGuncelleData) {
        seoUrlMethod = "seoUpdateUrl";
        update = link;
        link = this.yaziGuncelleData.link;
      }

      return new Promise(resolve => {
        RouterService[seoUrlMethod]({ link, update }).then(res => {
          this.editLinkLoading = false;
          if (res.status === 200) {
            this.yaziData.link = res.data;
          }
          resolve(res);
        });
      });
    },
    editorImgSrcParse(data) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, "text/html");
      var images = doc.body.querySelectorAll("img");

      if (images) {
        images.forEach(img => {
          img.src = img.src.replace(/(.*)\$apiImagesUrl/, this.$apiImagesUrl);
        });
      }

      return doc.body.innerHTML;
    },
    yaziEkle(publish) {
      const { baslik, icerik, link, thumbnail, seoIcerik, kategoriler, tags, fields } = this.yaziData;
      this.yaziDataLoading = true;
      YazilarService.yaziEkle({
        baslik,
        icerik,
        link,
        thumbnail,
        kategoriler,
        seoIcerik,
        publish,
        tags,
        fields,
        lang: this.currentLanguageCode
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.POST_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));

            let realPath = this.routerPath(1);
            this.$router.push(realPath);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .finally(() => {
          this.yaziDataLoading = false;
        })
        .catch(err => {
          this.yaziDataLoading = false;
        });
    },
    yaziyiGuncelle(publish) {
      const { yaziCode, baslik, icerik, link, thumbnail, seoIcerik, kategoriler, tags, fields } = this.yaziData;
      this.yaziDataLoading = true;
      YazilarService.yaziyiGuncelle({
        yaziCode,
        baslik,
        icerik,
        link,
        thumbnail,
        kategoriler,
        seoIcerik,
        publish,
        tags,
        fields,
        lang: this.currentLanguageCode
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.POST_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));

            let realPath = this.routerPath(2);
            this.$router.push(realPath);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .finally(() => {
          this.yaziDataLoading = false;
        })
        .catch(err => {
          this.yaziDataLoading = false;
        });
    },
    yaziyiKaldir() {
      const yaziCode = this.yaziKaldir.yaziCode;
      YazilarService.yaziyiKaldir({ yaziCode }).then(res => {
        if (res.status === 200) {
          this.$snotify.success(this.$t("YAZILAR.NOTIFY.POST_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          if (!this.yaziGuncelleData) {
            let realPath = this.routerPath(1);
            this.$router.push(realPath);
          } else {
            let realPath = this.routerPath(1);
            this.$router.push(realPath);
          }
        }
      });
    },
    yaziyiKaldirDialog(yaziCode) {
      this.yaziKaldir.yaziCode = yaziCode;
      this.yaziKaldir.dialog = true;
    },
    routerPath(num) {
      let path = this.$route.path.split("/");
      for (let i = 0; i < num; i++) {
        path.pop();
      }
      return path.join("/");
    },
    idCounter() {
      return this.lastID++;
    },
    kategoriParser(cats, parent = []) {
      if (parent.length === 0) {
        /**
         * En üst kategoriyi al
         */
        parent = _.find(cats, { parent: 0 });
      }

      /**
       * Üst kategoriyi kaldır
       */
      var catList = _.remove(cats, o => {
        return o.parent !== 0;
      });

      /**
       * Listeden alt kategoriyi/kategorileri getir
       */
      var cat = _.filter(catList, {
        parent: parent.code
      });

      /**
       * Alt kategorileri tekrar tekrar oluştur
       */
      if (cat.length > 0) {
        parent.children = [];
        cat.forEach(d => {
          parent.children.push(this.kategoriParser(JSON.parse(JSON.stringify(catList)), JSON.parse(JSON.stringify(d))));
        });
      }

      /**
       * ID numarası ekle
       */
      parent.id = parent.code;

      /**
       * Sonucu döndür
       */
      return parent;
    },
    findID(catList, id) {
      var result;
      catList.forEach(cat => {
        if (cat.id === id) {
          return (result = cat);
        } else if (cat.children) {
          let find = this.findID(cat.children, id);
          return (result = find ? find : result);
        }
      });
      return result;
    },
    
    languageStructuredIsChanged({oldCode, currentCode}) {
      this.currentCode = currentCode;

      // if (this.widgetList[currentCode].widgetList.length) {
      //   this.preparedForWidgetList = JSON.parse(JSON.stringify(this.widgetList[currentCode].widgetList));
      // } else {
      //   this.preparedForWidgetList = [];
      // }
    },
  },
  created() {
    /**
     * Site adresini getir
     */
    OptionService.getInput({ option: "genel", inputName: "siteAdresi" }).then(({ status, data }) => {
      if (status === 200 && data) {
        let urlMatch = data.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)/);
        if (urlMatch) {
          this.siteUrl = data[data.length - 1] !== "/" ? data + "/" : data;
        } else {
          this.siteUrl = this.defaultUrl;
        }
      } else {
        this.siteUrl = this.defaultUrl;
      }
    });

    /**
     * Yazı kategorilerini getir
     */
    this.$store
      .dispatch("Yazilar/YaziKategorileri/kategoriListesi")
      .then(res => {
        /**
         * Ürün kategorileri listesini getir
         */
        var grouped = _.mapValues(_.groupBy(res.data, "hierarchy"));
        var catList = [];
        Object.keys(grouped).forEach(groupKey => {
          catList.push(this.kategoriParser(JSON.parse(JSON.stringify(grouped[groupKey]))));
        });
        this.yaziKategorileri = catList;
        return res;
      })
      .then(res => {
        /**
         * Kapalı olan tüm kategori ağacını aktif et
         */
        for (let cat of res.data) {
          this.treeViewAktifKategoriler.push(cat.code);
        }
      })
      .then(() => {
        /**
         * Yazının düzenleme olup olmadığını kontrol et
         */
        if (this.$route.params.yaziID) {
          const yaziCode = Number(this.$route.params.yaziID);
          const lang = this.$route.query.lang;
          return YazilarService.yaziDetay({ yaziCode, lang: lang || this.currentLanguageCode })
            .then(res => {
              if (res.status === 200) {
                this.yaziGuncelleData = res.data;
                for (let key in this.yaziDataMap) {
                  if (Object.hasOwnProperty.call(this.yaziData, key)) {
                    this.yaziData[key] = this.yaziGuncelleData[this.yaziDataMap[key]];
                  }
                }

                this.editorIcerik = this.editorImgSrcParse(this.yaziGuncelleData.desc);
                this.setContent = this.editorImgSrcParse(this.yaziGuncelleData.desc);

                this.yaziData.tags = this.yaziGuncelleData.tags.split(",");
                // this.yaziData.baslik = prepareFromData(this.yaziData.baslik, {items: 'baslik'});

                this.secilenYaziKategorileri = _.map(this.yaziGuncelleData.category, c => c.category);
              } else {
                this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
                this.$router.back();
              }
            })
            .then(() => {
              if (this.yaziGuncelleData) {
                /**
                 * Güncelleme verisindeki yazinın alt yazilarını seçilemeyecek
                 * biçimde iptal et
                 */
                let hierarchy = this.yaziGuncelleData.hierarchy,
                  code = this.yaziGuncelleData.code;

                let yaziGuncelleParent = _.filter(this.yaziListesi, s => s.hierarchy === hierarchy),
                  page = _.find(yaziGuncelleParent, s => {
                    return s.code === code;
                  });

                let yaziListesi = this.yaziListesi;
                _.remove(yaziListesi, s => {
                  return (s.depth > page.depth && s.hierarchy === hierarchy) || s.code === code;
                });

                this.$set(this, "yaziListesi", yaziListesi);
              }
            });
        }
      })
      .then(() => {
        this.guncelYaziListesi = this.yaziListesi;
      });
  },
  watch: {
    editorIcerik(data) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, "text/html");
      let images = doc.body.querySelectorAll("img");

      if (images) {
        Object.keys(images).forEach(i => {
          images[i].src = String(images[i].src).replace(`${this.$apiImagesUrl}`, "$apiImagesUrl");
        });
      }

      if (!this.seoIcerikEvent) {
        let newLines = parser.parseFromString(doc.body.innerHTML.replaceAll("><", "> <"), "text/html"),
          seoIcerik = newLines.body.innerText;
        if (seoIcerik.length <= this.seoIcerikLimit) {
          this.yaziData.seoIcerik = seoIcerik.trim();
        }
      }
      this.yaziData.icerik = doc.body.innerHTML;
    },

    /**
     * Başlık değiştiği zaman seo link üret
     */
    "yaziData.baslik"(value) {
      if (this.baslikTimeout) {
        clearTimeout(this.baslikTimeout);
      }

      this.baslikTimeout = setTimeout(() => {
        this.checkLink(value);
      }, this.baslikSeoLinkTimeout);
    },
    secilenYaziKategorileri: {
      handler(value) {
        let kategoriler = [];
        value.forEach(sec => {
          let find = this.findID(this.yaziKategorileri, sec);
          if (find) kategoriler.push(find.code);
        });
        this.yaziData.kategoriler = kategoriler;
      },
      immediate: true
    }
  }
};
</script>

<style>
.yazi-field .v-input__append-outer {
  display: flex;
  align-items: center;
  margin-top: 0 !important;
  height: 100%;
}
</style>
